import { render, staticRenderFns } from "./ProcessingPlacements.vue?vue&type=template&id=161ca959&"
import script from "./ProcessingPlacements.vue?vue&type=script&lang=js&"
export * from "./ProcessingPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports